import React from "react";
import { Link } from "@reach/router";
import { Grid } from "@material-ui/core";
import { EligibilityFormContext_submission_form as FormType } from "types/gql-types";
import FormInfo from "components/haven-design/form/info";
import { humanizeFormType } from "utils/form-types";
import Header from "components/header";

type ApplicationSuccessfulProps = {
  path?: string,
  form: FormType,
  propertyName?: string
}
const ApplicationSuccessful: React.FC<ApplicationSuccessfulProps> = (props) => (
  <>
    <Header />
    <div className="container">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormInfo title="Thank you!" type="Success">
            Thank you for submitting your {humanizeFormType(props.form.type)}
            {props.propertyName && ` to ${props.propertyName}`}!<br />
            Please check your email or cell number for your&nbsp;
            receipt or you can print this page.<br />
            You can login at <Link to="/login">app.havenconnect.com/login </Link>
             to update your information in the future.<br />
          </FormInfo>
        </Grid>
        <Grid item>
          <Link to="/properties">Find & apply to other properties</Link>
        </Grid>
      </Grid>
    </div>
  </>
);

export default ApplicationSuccessful;
